import { reportError } from '@/services/errorReporting.ts';

const isUntrackedAuthAction = (storeId, actionName) => storeId === 'auth' && (actionName === 'login' || actionName === 'logout');

export default function posthogPiniaPlugin({ store }) {
	store.$onAction(({ name, onError }) => {
		onError((error) => {
			if (isUntrackedAuthAction(store.$id, name)) return;

			reportError(error, {
				source: 'pinia',
				domain: `store:${store.$id}`,
				operation: name,
				handled: false,
				details: {
					store: store.$id,
					action: name
				}
			});
		});
	});
}
